module.exports = __webpack_public_path__ + "static/media/request-example.ac19eff4.png";